module.exports = __webpack_public_path__ + "img/reissueStudent.7d577135.svg";